export class EmployeeAdminTaskAddress {
    taskId: string;
    streetAddressNameNumberAndLetter: string;
    addressDescription: string;
    addressIsPermanent: boolean;
    zipCode: string;
    latitude: string;
    longitude: string;
    municipalityName: string;
    zipCodeWarning: boolean;
    zipCodeSuggestion: string;
    addressValid: boolean;

    constructor(taskId: string, streetAddressNameNumberAndLetter: string, zipCode: string) {
        this.taskId = taskId;
        this.streetAddressNameNumberAndLetter = streetAddressNameNumberAndLetter;
        this.zipCode = zipCode;
    }
}
